
import { Vue, Component, Watch } from 'vue-property-decorator';
import MessageInput from './MessageInput.vue';
import { isWeiXin, inAppAlertLogin, WechatLogin } from '@/common/ts/common';
import { Popup, Toast, NumberKeyboard } from 'vant';
import SlideVerify from './SlideVerify.vue';
import { valisendMsg, webSendMsg, bind3rdParty } from '@/api/api';
Vue.use(Popup)
  .use(Toast)
  .use(NumberKeyboard);
@Component({
  components: {
    SlideVerify,
    MessageInput,
  },
})
export default class MessageLogin extends Vue {
  messageValue: string = '';
  showKeyboard: boolean = true;
  returnButton: boolean = false;
  SlideShow: boolean = false;
  content: string = '60秒后重新发送';
  total: number = 60;
  phone: any = '';
  created() {
    window.setInterval(() => {
      this.total--;
      if (this.total <= 0) {
        this.content = '重新发送';
        this.returnButton = true;
      } else {
        this.content = this.total + '秒后重新发送';
      }
    }, 1000);
    this.phone = this.$route.query.phone;
  }
  onInput(key: any) {
    this.messageValue = (this.messageValue + key).slice(0, 6);
  }
  onDelete() {
    this.messageValue = this.messageValue.slice(
      0,
      this.messageValue.length - 1,
    );
  }
  sendMessage() {
    this.SlideShow = true;
  }
  getSlideData(e: any) {
    const data = {
      phone: this.phone,
      sessionid: e.csessionid,
      sig: e.sig,
      token: e.token,
      scene: e.scene,
      smsType: 2,
    };

    webSendMsg(data).then((res: any) => this.enterMessageLoginPage(res));
    this.SlideShow = false;
  }
  enterMessageLoginPage(res: any) {
    if (res.statusCode === 200) {
      Toast('短信发送成功');
    } else {
      Toast(res.message);
      setTimeout(() => {
        this.$router.go(-1);
      }, 2000);
    }
  }
  bind() {
    const data = {
      phone: this.$route.query.phone as string,
      code: this.messageValue,
      smsType: 2,
    };
    valisendMsg(data).then((res: any) => this.enterWeb(res));
  }
  async enterWeb(res: any) {
    if (res.statusCode === 200) {
      const data = {
        type: 2,
        unionId: window.localStorage.getItem('unionid'),
        phone: this.$route.query.phone as string,
        verificationValue: res.data,
        nickName: window.localStorage.getItem('nickname'),
        userPic: window.localStorage.getItem('headimgurl'),
      };
      const ret: any = await bind3rdParty(data);
      if (ret.statusCode === 200) {
        Toast('绑定成功！');
        setTimeout(() => {
          location.href = decodeURIComponent(this.$route.query.url as string);
        }, 1000);
      } else {
        Toast(res.message);
        setTimeout(() => {
          location.href = decodeURIComponent(this.$route.query.url as string);
        }, 1000);
      }
    } else {
      Toast(res.message);
      this.messageValue = '';
    }
  }
}
// bindPhone(){

// }
